import styled, { css } from 'styled-components';

export const Layout = styled.div<{ $compact?: boolean }>(
  ({ theme, $compact }) => css`
    max-width: ${$compact ? 'unset' : theme.sz.sm};
    display: grid;
    grid-template-columns: 1fr;
    gap: ${$compact ? theme.sz.s4 : theme.sz.s12};
    justify-items: center;

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
      max-width: unset;
    }
  `,
);

export const MicIconWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral98};
    color: ${theme.co.neutral60};
    font-size: ${theme.sz.s16};
    padding: ${theme.sz.s4};

    @media (max-width: ${theme.sz.md}) {
      justify-self: start;
    }
  `,
);

export const TextsWrapper = styled.div(
  () => css`
    width: 100%;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.secondary20};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s1};
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary20};
  `,
);

export const ButtonWrapper = styled.div(
  ({ theme }) => css`
    min-width: ${theme.sz.s54};

    @media (max-width: ${theme.sz.ms}) {
      width: 100%;
    }
  `,
);
